import { EyeOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';

export const getVehiculoColumns = (onEdit, onView) => [
  {
    title: 'Placa',
    dataIndex: 'placa',
    key: 'placa',
    sorter: (a, b) => a.placa.localeCompare(b.placa),
  },
  {
    title: 'Marca',
    dataIndex: 'marca',
    key: 'marca',
    sorter: (a, b) => a.marca.localeCompare(b.marca),
  },
  {
    title: 'Modelo',
    dataIndex: 'modelo',
    key: 'modelo',
    sorter: (a, b) => a.modelo.localeCompare(b.modelo),
  },
  {
    title: 'Color',
    dataIndex: 'color',
    key: 'color',
    sorter: (a, b) => a.color.localeCompare(b.color),
  },
  {
    title: 'Tipo Gasolina',
    dataIndex: 'tipo_gasolina',
    key: 'tipo_gasolina',
    sorter: (a, b) => a.tipo_gasolina.localeCompare(b.tipo_gasolina),
  },
  {
    title: 'Engomado',
    dataIndex: 'engomado',
    key: 'engomado',
    sorter: (a, b) => a.engomado.localeCompare(b.engomado),
  },
  {
    title: 'Acciones',
    key: 'acciones',
    render: (text, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="ver" icon={<EyeOutlined />} onClick={() => onView(record)}>
              Ver
            </Menu.Item>
            <Menu.Item key="editar" icon={<EditOutlined />} onClick={() => onEdit(record)}>
              Editar
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button type="default" icon={<EyeOutlined />} />
      </Dropdown>
    ),
  },
];
